import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'fixed',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
  colorProgress: {
      color: '#D4E157'
  }
}));


export default function CircularIndeterminate() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress className={classes.colorProgress}  />
    </div>
  );
}